var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6 36.4c-.4 0-.9-.3-1-.8l-1.3-5.2c-.1-.5.2-1.1.7-1.2s1.1.2 1.2.7l1.3 5.2c.1.5-.2 1.1-.7 1.2 0 .1-.1.1-.2.1z",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9 36.4H4.4c-1.5 0-2.8-.7-3.7-1.9-.8-1.1-.9-2.4-.5-3.7.9-2.3 3.5-3.3 7.9-3 1.3.1 2.5.8 3 1.9.6 1 .3 1.8.1 2.2-.6 1.1-2.1 1.6-4.8 1.7-.5 0-1-.4-1-1s.4-1 1-1c2.6-.1 3-.6 3.1-.7 0 0 0-.1-.1-.3-.3-.5-.8-.8-1.4-.8-2.3-.2-5.2 0-5.8 1.7-.3.8 0 1.5.3 1.8.5.6 1.2 1 2 1H9c.6 0 1 .5 1 1s-.5 1.1-1.1 1.1zM52.4 36.4h-.3c-.5-.1-.9-.7-.7-1.2l1.3-5.2c.1-.5.7-.9 1.2-.7.5.1.9.7.7 1.2l-1.3 5.2c0 .4-.5.7-.9.7z",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6 36.4h-4.5c-.6 0-1-.5-1-1s.5-1 1-1h4.5c.8 0 1.6-.4 2-1 .2-.3.6-1 .3-1.8-.6-1.7-3.5-1.9-5.8-1.7-.6 0-1.2.4-1.4.8-.1.2-.1.3-.1.3s.4.6 3.2.7c.6 0 1 .5 1 1 0 .6-.5 1-1 1-2.7-.1-4.2-.6-4.8-1.7-.2-.4-.5-1.2.1-2.2.6-1.1 1.7-1.8 3-1.9 4.4-.3 7 .7 7.9 3 .5 1.2.3 2.6-.5 3.7-1.1 1.1-2.4 1.8-3.9 1.8z",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 44c-.4 0-.8-.2-.9-.6L.6 34.3c-.2-.5 0-1 .5-1.3.5-.2 1-.1 1.3.3.4.7 1.2 1.1 2 1.1h55.2c.8 0 1.6-.4 2-1.1.3-.4.8-.6 1.3-.3.5.2.7.8.5 1.3l-3.5 9.1c-.2.5-.8.8-1.3.6s-.8-.8-.6-1.3l2.4-6.3c-.3.1-.6.1-.9.1H4.4c-.3 0-.6 0-.9-.1l2.4 6.3c.2.5-.1 1.1-.6 1.3H5zM48.8 63.1H15.2c-2.1 0-4-1.3-4.8-3.3l-.1-.4c-.2-.5.1-1.1.6-1.3s1.1.1 1.3.6l.1.4c.4 1.2 1.6 2 2.9 2h33.6c1.3 0 2.4-.8 2.9-2l.1-.3c.2-.5.8-.8 1.3-.6s.8.8.6 1.3l-.1.4c-.7 1.9-2.7 3.2-4.8 3.2zM11.2 57.1c-4.7 0-7.8-3.3-8.4-8.9-.1-.8.2-1.6.7-2.2.7-.8 1.8-1.2 2.9-.9.5.1 1.1.1 1.7 0s1.2-.2 1.8-.4c1-.2 2-.4 3-.4 2 0 3.3 1.1 3.8 3.3.7 3.2.3 6-1 7.7-1 1.1-2.5 1.8-4.5 1.8zM5.9 47c-.3 0-.6.1-.8.4-.1 0-.3.3-.2.6.3 2.7 1.4 7.1 6.4 7.1v1-1c1.3 0 2.3-.4 2.9-1.2 1-1.2 1.2-3.5.7-6-.3-1.6-1-1.7-1.8-1.7-.7 0-1.6.2-2.5.4-.6.1-1.3.3-1.9.4-.9.1-1.7.1-2.5 0h-.3zM52.8 57.1c-1.9 0-3.5-.7-4.5-2-1.4-1.7-1.8-4.5-1-7.7.5-2.2 1.7-3.3 3.8-3.3.9 0 1.9.2 3 .4.6.1 1.2.3 1.8.4.7.1 1.3.1 1.7 0 1.2-.2 2.2.1 3 .9.6.6.8 1.4.7 2.2-.7 5.8-3.8 9.1-8.5 9.1zM51 46.2c-.8 0-1.5.1-1.8 1.7-.6 2.5-.3 4.8.7 6 .6.8 1.6 1.2 2.9 1.2v1-1c5 0 6.1-4.5 6.4-7.1 0-.3-.1-.6-.2-.7-.3-.3-.7-.4-1.1-.3-.7.2-1.6.2-2.5 0-.6-.1-1.3-.2-1.9-.4-1-.2-1.8-.4-2.5-.4zM32 32.1c-5.7 0-10.4-4.7-10.4-10.4 0-.7.1-1.4.2-2.1.1-.5.5-.8 1-.8h18.4c.5 0 .9.3 1 .8.1.7.2 1.5.2 2.1 0 5.8-4.7 10.4-10.4 10.4zm-8.3-11.3c0 .3-.1.6-.1.9 0 4.6 3.8 8.4 8.4 8.4s8.4-3.8 8.4-8.4c0-.3 0-.6-.1-.9z",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 20.8H19.9c-.7 0-1.3-.3-1.7-.9-.4-.5-.5-1.2-.2-1.8.3-.7.6-1.3 1.2-1.8.9-.9 2.1-1.4 3.5-1.4h18.9c2.1 0 3.9 1.3 4.6 3.3.2.6.1 1.3-.2 1.8-.6.5-1.2.8-1.8.8zm-21.7-3.9c-.8 0-1.5.3-2 .8-.3.3-.5.7-.7 1.1l24.3-.1c-.4-1.1-1.5-1.9-2.7-1.9H22.5z",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 16.9h-21c-.6 0-1-.4-1-1v-.5c0-3.5 1.6-6.8 4.4-9 .4-.3 1.1-.3 1.4.2.3.4.2 1-.2 1.4-2.2 1.7-3.5 4.2-3.6 7h19c-.1-2.4-1.1-4.6-2.8-6.2-.2-.2-.5-.5-.8-.7-.4-.3-.5-1-.2-1.4s1-.5 1.4-.2.7.6 1 .9c2.2 2.2 3.4 5.1 3.4 8.1v.5c0 .5-.4.9-1 .9z",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 10.7c-.6 0-1-.4-1-1V4.4c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v5.3c0 .6-.4 1-1 1s-1-.4-1-1V4.4c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5v5.3c0 .5-.4 1-1 1z",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.92e5f013c088546e3464588cb4a0123d.svg";
export { ForwardRef as ReactComponent };